import { render, staticRenderFns } from "./CollapseAbbreviations.vue?vue&type=template&id=889c28ac"
import script from "./CollapseAbbreviations.vue?vue&type=script&lang=js"
export * from "./CollapseAbbreviations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports